import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Jeff Anders
 * id BBEAE49B-BA87-4375-A642-83196A4999F6
 * name bookmark-box
 * version: 7.0.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/bookmark-box.svg
 * tags
 */
export const BookmarkBoxIcon = createSvgIcon(<><path d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3M18 14L15.5 12.5L13 14V6H18V14Z" /></>, 'BookmarkBoxIcon');
export default BookmarkBoxIcon